const HeaderSticky = function (element) {
	// GENERAL SETTINGS
	const theHtml = document.documentElement;
	const body = document.body;
	const breakPoint = 769;
	// HEADER
	const rowSticky = '[data-sticky-header-position]';
	// MENU
	const buttonMenu = '[data-button-menu]';
	const menuItemHasSubmenu = '[data-item-menu-has-submenu]';
	// DRAWER
	const drawerCloseButton = '[data-drawer-close]';
	const drawerBackdrop = '[data-drawer-backdrop]';
	// SEARCH
	const buttonSearch = '[data-button-search]';

	let closeMenu = () => {};

	// Helper functions for DOM manipulation
	const toggleClass = (el, className) => {
		el.classList.toggle(className);
	};

	const addClass = (el, className) => {
		el.classList.add(className);
	};

	const removeClass = (el, className) => {
		el.classList.remove(className);
	};

	const hasClass = (el, className) => {
		return el.classList.contains(className);
	};

	// Slide animation helpers
	const slideDown = (el, duration = 300) => {
		el.style.display = 'block';
		const height = el.scrollHeight;
		el.style.height = '0';
		el.offsetHeight; // Trigger reflow
		el.style.transition = `height ${duration}ms ease`;
		el.style.height = height + 'px';
		setTimeout(() => {
			el.style.height = 'auto';
			el.style.transition = '';
		}, duration);
	};

	const slideUp = (el, duration = 300) => {
		el.style.height = el.scrollHeight + 'px';
		el.offsetHeight; // Trigger reflow
		el.style.transition = `height ${duration}ms ease`;
		el.style.height = '0';
		setTimeout(() => {
			el.style.display = 'none';
			el.style.transition = '';
		}, duration);
	};

	// DROPDOWN MENU
	const isDesktopViewport = () => window.innerWidth >= breakPoint;
	const isSubmenuOpen = (submenu) => submenu.style.display !== 'none' && submenu.style.display !== '';
	const menuToggleButton = '[data-menu-toggle]';

	const dropdownEntries = [];
	const toggleEntries = [];
	document.querySelectorAll(menuItemHasSubmenu).forEach((menuItem) => {
		const submenu = menuItem.querySelector('ul');
		if (!submenu) return;
		const toggleButton = menuItem.querySelector(menuToggleButton);
		if (toggleButton) {
			toggleEntries.push({ menuItem, submenu, toggleButton });
		} else {
			dropdownEntries.push({ menuItem, submenu, menuScrollNav: menuItem.closest('[data-menu-scroll]') });
		}
	});

	const openDropdownSubmenu = ({ menuItem, submenu, menuScrollNav }) => {
		if (menuScrollNav) {
			menuScrollNav.appendChild(submenu);
			const itemRect = menuItem.getBoundingClientRect();
			const navRect = menuScrollNav.getBoundingClientRect();
			submenu.style.left = (itemRect.left - navRect.left) + 'px';
		}
		addClass(menuItem, 'is-submenu-open');
		slideDown(submenu, 300);
	};

	const closeDropdownSubmenu = ({ menuItem, submenu }) => {
		removeClass(menuItem, 'is-submenu-open');
		slideUp(submenu, 300);
	};

	const resetDropdownMenu = () => {
		dropdownEntries.forEach(({ menuItem, submenu }) => {
			if (isDesktopViewport()) {
				removeClass(menuItem, 'is-submenu-open');
				submenu.style.display = 'none';
			} else {
				menuItem.appendChild(submenu);
				submenu.style.left = '';
				submenu.style.height = '';
				submenu.style.transition = '';
				submenu.style.display = 'block';
			}
		});
	};

	dropdownEntries.forEach((entry) => {
		const { menuItem, submenu } = entry;

		let closeTimer = null;
		const cancelClose = () => {
			if (closeTimer) {
				clearTimeout(closeTimer);
				closeTimer = null;
			}
		};
		const scheduleClose = () => {
			cancelClose();
			closeTimer = setTimeout(() => closeDropdownSubmenu(entry), 150);
		};

		menuItem.addEventListener('mouseenter', () => {
			if (!isDesktopViewport()) return;
			cancelClose();
			openDropdownSubmenu(entry);
		});

		menuItem.addEventListener('mouseleave', () => {
			if (!isDesktopViewport()) return;
			scheduleClose();
		});

		submenu.addEventListener('mouseenter', cancelClose);

		submenu.addEventListener('mouseleave', () => {
			if (!isDesktopViewport()) return;
			scheduleClose();
		});

		// Keyboard handling
		submenu.querySelectorAll('a, button').forEach(btn => {
			btn.addEventListener('keydown', (e) => {
				if (!isDesktopViewport()) return;
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					if (isSubmenuOpen(submenu)) {
						closeDropdownSubmenu(entry);
					} else {
						openDropdownSubmenu(entry);
					}
				}
			});
		});
	});

	window.addEventListener('load', resetDropdownMenu);
	window.addEventListener('resize', resetDropdownMenu);

	toggleEntries.forEach(({ menuItem, submenu, toggleButton }) => {
		toggleButton.addEventListener('click', () => {
			if (isSubmenuOpen(submenu)) {
				removeClass(menuItem, 'is-submenu-open');
				toggleButton.setAttribute('aria-expanded', 'false');
				slideUp(submenu, 300);
			} else {
				addClass(menuItem, 'is-submenu-open');
				toggleButton.setAttribute('aria-expanded', 'true');
				slideDown(submenu, 300);
			}
		});
	});
	// end DROPDOWN MENU

	// HEADER
	const rowStickyElement = document.querySelector(rowSticky);
	if (rowStickyElement) {
		const handleScroll = () => {
			const rowStickyPosition = rowStickyElement.offsetTop;
			if (window.scrollY > rowStickyPosition) {
				removeClass(body, 'has-full-header');
				if (hasClass(body, 'main-header')) {
					addClass(body, 'has-sticky-header');
				}
			} else {
				if (hasClass(body, 'main-header')) {
					addClass(body, 'has-full-header');
					removeClass(body, 'has-sticky-header');
				}
				if (hasClass(body, 'has-menu-opened')) {
					closeMenu();
				}
				removeClass(body, 'has-search-opened');
			}
		};

		window.addEventListener('load', handleScroll);
		window.addEventListener('scroll', handleScroll);
	}
	// end HEADER

	// HIDE HEADER TOP
	if (window.innerWidth < 768) {
		let lastScrollTop = 0;
		const delta = 15;

		window.addEventListener('scroll', () => {
			const st = window.scrollY;

			if (Math.abs(lastScrollTop - st) <= delta) return;

			lastScrollTop = st;
		});
	}
	// end HIDE HEADER TOP

	const menuButton = document.querySelector(buttonMenu);
	const drawerCloseEl = document.querySelector(drawerCloseButton);
	const drawerBackdropEl = document.querySelector(drawerBackdrop);
	if (menuButton) {
		const openMenu = () => {
			if (hasClass(body, 'has-search-opened')) {
				removeClass(body, 'has-search-opened');
			}
			addClass(body, 'has-menu-opened');
			addClass(theHtml, 'no-scroll');
			menuButton.setAttribute('aria-expanded', 'true');
			menuButton.setAttribute('aria-label', 'Cerrar menú de navegación');
			if (drawerCloseEl) {
				drawerCloseEl.focus();
			}
		};

		closeMenu = () => {
			removeClass(body, 'has-menu-opened');
			removeClass(theHtml, 'no-scroll');
			menuButton.setAttribute('aria-expanded', 'false');
			menuButton.setAttribute('aria-label', 'Abrir menú de navegación');
			menuButton.focus();
		};

		const handleMenuButton = (event) => {
			if (event.type === 'keydown' && !(event.key === 'Enter' || event.key === ' ')) return;
			event.preventDefault();

			if (hasClass(body, 'has-menu-opened')) {
				closeMenu();
			} else {
				openMenu();
			}
		};

		menuButton.addEventListener('click', handleMenuButton);
		menuButton.addEventListener('keydown', handleMenuButton);

		if (drawerCloseEl) {
			drawerCloseEl.addEventListener('click', closeMenu);
			drawerCloseEl.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					closeMenu();
				}
			});
		}

		if (drawerBackdropEl) {
			drawerBackdropEl.addEventListener('click', closeMenu);
		}

		const drawerEl = document.querySelector('[data-drawer]');
		const getFocusableElements = () => {
			if (!drawerEl) return [];
			return Array.from(
				drawerEl.querySelectorAll('a[href], button, [role="button"], input, [tabindex]:not([tabindex="-1"])')
			).filter((el) => el.offsetParent !== null);
		};

		document.addEventListener('keydown', (event) => {
			if (!hasClass(body, 'has-menu-opened')) return;

			if (event.key === 'Escape') {
				closeMenu();
				return;
			}

			if (event.key !== 'Tab') return;

			const focusable = getFocusableElements();
			if (!focusable.length) return;

			const first = focusable[0];
			const last = focusable[focusable.length - 1];

			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		});
	}
	// end MENU BUTTON + DRAWER

	const searchButton = document.querySelector(buttonSearch);
	if (searchButton) {
		searchButton.addEventListener('click', () => {
			if (hasClass(body, 'has-menu-opened')) {
				closeMenu();
			}
			toggleClass(body, 'has-search-opened');
		});
	}
	// end SEARCH BUTTON

	// MENU SCROLL 
	document.querySelectorAll('[data-menu-scroll]').forEach((menuScrollRoot) => {
		const menuScrollList = menuScrollRoot.querySelector('[data-menu-scroll-list]');
		const menuScrollFadePrev = menuScrollRoot.querySelector('[data-menu-scroll-fade="prev"]');
		const menuScrollFadeNext = menuScrollRoot.querySelector('[data-menu-scroll-fade="next"]');
		const menuScrollBtnPrev = menuScrollRoot.querySelector('[data-menu-scroll-btn="prev"]');
		const menuScrollBtnNext = menuScrollRoot.querySelector('[data-menu-scroll-btn="next"]');

		const updateMenuScroll = () => {
			const max = menuScrollList.scrollWidth - menuScrollList.clientWidth;
			const hasOverflow = max > 1;
			const atStart = menuScrollList.scrollLeft <= 1;
			const atEnd = menuScrollList.scrollLeft >= max - 1;

			menuScrollFadePrev.classList.toggle('is-visible', hasOverflow && !atStart);
			menuScrollFadeNext.classList.toggle('is-visible', hasOverflow && !atEnd);
			menuScrollBtnPrev.classList.toggle('is-visible', hasOverflow && !atStart);
			menuScrollBtnNext.classList.toggle('is-visible', hasOverflow && !atEnd);
		};

		const scrollMenuBy = (direction) => {
			menuScrollList.scrollBy({ left: direction * menuScrollList.clientWidth * 0.6, behavior: 'smooth' });
		};

		menuScrollBtnPrev.addEventListener('click', () => scrollMenuBy(-1));
		menuScrollBtnNext.addEventListener('click', () => scrollMenuBy(1));
		menuScrollList.addEventListener('scroll', updateMenuScroll, { passive: true });
		window.addEventListener('load', updateMenuScroll);
		window.addEventListener('resize', updateMenuScroll);
	});
	// end MENU SCROLL
};

export default HeaderSticky;
